import React, { useMemo } from 'react';
import { MetricCard, SpinnerDotted } from '../../atoms';
import { AttentionAlert, UserAlert } from '../../atoms/alerts';
import { LodingSquareTabbar, PreferredPartner } from '../../molecules';
import { RatingCard, CommentSection, DoughnutGraph, Bargraph } from '../../organisms';
import { totalamont, reduceCost, WellnessCalendar, calender_img, info_icon, WalletIcon } from '../../../../assets/images';
import { commaingNumber } from '../../../../utils';
import WalletUtilizationCommon from './WalletUtilizationCommon';
import { UtilizationSankyChart } from '../../../tailwind/organisms';
import { Tooltip } from 'antd';

const Benefit = ({ metricObj, ratingObj, utilizationObj, costSavingObj, sqaureTabHandler, loading, selectedContractObj, benefitType, benefitName, walletUtilizationObj, showNoUtilization}) => {
  const {
    healthCheckAvailedPercentage, successMetric, donutGraphData, partners, activeEmployeesAppointmentsCount, inactiveEmployeesAppointmentsCount,
    activeDependentsAppointmentsCount, inactiveDependentsAppointmentsCount, totalHealthChecksCompleted, unique_users, repeat_users, activeCustomerCount,
    activeEmployeesUpcomingAppointmentsCount, activeDependentsUpcomingAppointmentsCount
  } = metricObj;
  const { totalWalletAmount, walletEnable } = walletUtilizationObj;

  const { ratingsPercent, totalratings, averagerating, commentSectionData } = ratingObj;
  const { barlabels, bardata, barBgColors, xAxesLabel } = utilizationObj;
  const { appointment_count, cost, savings, self_savings } = costSavingObj;
  const currentYear = selectedContractObj?.is_running_contract

  const tooltipText = (selfCount = 0, dependentCount = 0) => {
    return (
      <div>
        {employeeData('Self appointments', selfCount)}
        {employeeData('Dependents appointments', dependentCount)}
        <hr className='my-3' />
        {employeeData('Total appointments', selfCount + dependentCount)}
      </div>  
    )
  }

  const benefitArrForSponsoredAndMoneySpent = ['ahc', 'dental', 'vision']

  const employeeData = (text, count) => {
    return (
      <div className='flex justify-between'>
        <span className='font-semibold'>{text}</span>
        <span className='font-semibold'>{commaingNumber(count)}</span>
      </div>    
    )
  }

  const metricValueSuffix = (selfCount, dependentCount) => {
    return (
      <span >
        <span className='font-semibold text-gray-800'>
        Upcoming appointments
        </span>
        <Tooltip placement='bottom' title={tooltipText(selfCount, dependentCount)} overlayStyle={{width: '16rem'}}>
          <img src={info_icon} className='h-3 w-3 ml-1 inline cursor-pointer' alt='info_icon' />
        </Tooltip>
      </span>
    )
  }

  const sankyChartData = useMemo(() => {
    const employeesAppointmentsCount = activeEmployeesAppointmentsCount + activeDependentsAppointmentsCount
    const dependentsAppointmentsCount = inactiveEmployeesAppointmentsCount + inactiveDependentsAppointmentsCount

    const point1 = `Completed appointments (${totalHealthChecksCompleted || 0})`
    const point2 = `For active employees (${employeesAppointmentsCount || 0})`
    const point3 = `For inactive employees (${dependentsAppointmentsCount || 0})`
    const point4 = `For themselves (${activeEmployeesAppointmentsCount || 0}) `
    const point5 = `For dependents (${activeDependentsAppointmentsCount || 0}) `
    const point6 = `For themselves (${inactiveEmployeesAppointmentsCount || 0})`
    const point7 = `For dependents (${inactiveDependentsAppointmentsCount || 0})`


    const data = {
      nodes: [{ id: point1 }, { id: point2 },
              { id: point3 }, { id: point4 },
              { id: point5 }, { id: point6 },
              { id: point7 }],
      links: [
        {
          source: point1,
          target: point2,
          value: 75,
        },
        {
          source: point1,
          target: point3,
          value: 40,
        },
        {
          source: point2,
          target: point4,
          value: 49,
        },
        {
          source: point2,
          target: point5,
          value: 27,
        },
        {
          source: point3,
          target: point6,
          value: 23,
        },
        {
          source: point3,
          target: point7,
          value: 17,
        }
      ]
    }

    const colors = ['#0951E1', '#00A04F', '#C54B4F', '#1FBDC0', '#5163BA', '#4D6189', '#8895AF']
    
    return { data, colors }
  }, [totalHealthChecksCompleted])


  return (
    <div>
      {(!loading && currentYear && healthCheckAvailedPercentage < successMetric) &&
        <AttentionAlert
          title='Attention Required'
          description={
            <span>
              Utilization for your organization is low as per the success metrics set for your organization. To improve
              the utilization please reach out to your{' '}
              <span className='text-blue-500 font-semibold'>
                customer success manager.
              </span>
            </span>
          }
          classes='mt-6'
        />}
      <p className='text-gray-700 text-base font-semibold mt-8 mb-3 leading-none'>Sponsored {benefitName} checks</p>
      { !loading ?
        <>
          
          <div className='flex flex-row space-between'>
            { walletEnable && (totalWalletAmount >0) && (<MetricCard
              loading={loading}
              loaderHeight={120}
              svgsrc={WalletIcon}
              titleClasses='font-semibold text-gray-800'
              title='Total amount added'
              subTitle='Total amount added for employee and dependent wallet utilization'
              metricClasses='flex mt-0 text-gray-500'
              metricValue={<span className='ml-10 font-semibold text-3xl text-gray-700'>₹{commaingNumber(totalWalletAmount)}</span>}
              classes='w-1/2 inline-block mr-5'
            />)
            }
            { showNoUtilization == false && (<MetricCard
              loading={loading}
              loaderHeight={120}
              svgsrc={calender_img} 
              titleClasses='font-semibold text-gray-800'
              title='Completed appointments'
              subTitle='All completed appointments for self and dependents'
              metricClasses='flex mt-0 text-gray-500'
              metricValue={<span className='ml-10 font-semibold text-3xl text-gray-700'>{commaingNumber(totalHealthChecksCompleted)}</span>}
              metricValueSuffix='appointments'
              classes='w-1/2 inline-block mr-5'
            />)}
            { showNoUtilization == false && (<MetricCard
              loading={loading}
              loaderHeight={120}
              svgsrc={WellnessCalendar}
              titleClasses='font-semibold text-gray-800'
              title={metricValueSuffix(activeEmployeesUpcomingAppointmentsCount, activeDependentsUpcomingAppointmentsCount)}
              subTitle='All upcoming appointments for self and dependents'
              metricClasses='flex mt-0 text-gray-500'
              metricValue={<span className='ml-10 font-semibold text-3xl text-gray-700'>{commaingNumber(activeEmployeesUpcomingAppointmentsCount + activeDependentsUpcomingAppointmentsCount)}</span>}
              metricValueSuffix='appointments'
              classes='w-1/2 inline-block'
            />)}
          </div>

          { showNoUtilization == false && (<div><p className='text-gray-600 text-base font-semibold mt-8 mb-3 leading-none'>Appointments distribution</p>
       
        <UtilizationSankyChart sankeyData={sankyChartData} classes='px-9 py-20 border bg-white border-gray-200' height={450} /></div>)}
        </> :
        <div className='h-40 flex items-center justify-center'><SpinnerDotted /></div>
      }

      <WalletUtilizationCommon metricObj={metricObj}  loading={loading} benefitName={benefitName} walletUtilizationObj={walletUtilizationObj} uniqueUsers={unique_users} activeCustomerCount={activeCustomerCount}/>
    { showNoUtilization == false && (<div>
      <div className='flex flex-row justify-between mt-12'>
        <div className='flex flex-col w-1/2 mr-4'>
          <p className='text-gray-500 text-base font-semibold mt-0 mb-3 leading-none'>{benefitName} Distribution</p>
          <DoughnutGraph
            loading={loading}
            loaderHeight={200}
            title={benefitName}
            graphData={donutGraphData}
            classes='h-full'
            heightOfLoader={200}
            id={benefitType}
          />
        </div>
        <div className='flex flex-col w-1/2'>
          <p className='text-gray-500 text-base font-semibold mt-0 mb-3 leading-none'>
            Top preferred partners by your employees
          </p>
          <PreferredPartner loading={loading} loaderHeight={200} list={partners} header='Partners' classes='h-full' />
        </div>
      </div>

      <div>
        {benefitArrForSponsoredAndMoneySpent.includes(benefitType) &&(
        <div>
          <p className='text-gray-500 text-base font-semibold mt-12 mb-3 leading-none'>
            Spent and savings on {benefitName?.toLowerCase()}
          </p>
            <div className='flex flex-row'>
              <MetricCard
                loading={loading}
                loaderHeight={120}
                svgsrc={totalamont}
                titleClasses='block'
                title={`Total amount spent on sponsored ${benefitName?.toLowerCase()}`}
                metricValue={<span className='font-semibold text-3xl text-gray-700 mt-3'>₹{commaingNumber(cost)}</span>}
                classes='w-1/3 inline-block mr-5'
              />
              <MetricCard
                loading={loading}
                loaderHeight={120}
                svgsrc={reduceCost}
                titleClasses='block'
                title={`Amount saved by you on sponsored ${benefitName?.toLowerCase()}`}
                metricValue={<span className='font-semibold text-3xl text-gray-700'>₹{commaingNumber(savings)}</span>}
                classes='w-1/3 inline-block mr-5'
              />
              <MetricCard
                loading={loading}
                loaderHeight={120}
                svgsrc={reduceCost}
                titleClasses='block'
                title={
                  <span>
                    Amount saved by you on self paid {benefitName?.toLowerCase()}<span className='font-semibold text-lg leading-3'>*</span>
                  </span>
                }
                metricValue={<span className='font-semibold text-3xl text-gray-700'>₹{commaingNumber(self_savings)}</span>}
                classes='w-1/3 inline-block'
              />
            </div>
          <p className='text-sm text-gray-600 mt-2 mb-0 italic leading-none'>
            <span className='font-semibold'>*{appointment_count}</span> additional tests/packages were availed by
              employees/dependents on self paid basis
          </p>
        </div>)}
      </div>

      <div className='flex flex-row mt-12'>
        <div className='flex flex-col w-2/4 pr-4'>
          <div className='text-base font-semibold text-gray-500 leading-none mb-1'>Ratings and Reviews</div>
          <div className='text-sm mb-3 text-gray-600'>
            These ratings are captured after completing the {benefitName?.toLowerCase()}.
          </div>
          <RatingCard
            loading={loading}
            loaderHeight={200}
            rating={averagerating}
            number_of_ratings={totalratings}
            five_star_rating={ratingsPercent && ratingsPercent[4]}
            four_star_rating={ratingsPercent && ratingsPercent[3]}
            three_star_rating={ratingsPercent && ratingsPercent[2]}
            two_star_rating={ratingsPercent && ratingsPercent[1]}
            one_star_rating={ratingsPercent && ratingsPercent[0]}
            classes='h-full'
          />
        </div>

        <div className='w-2/4 flex flex-col'>
          <div className='text-base font-semibold text-gray-500 leading-none mb-1'>Top Comments</div>
          <div className='text-sm mb-3 text-gray-600'>
            These reviews are captured after completing the {benefitName?.toLowerCase()}.
          </div>
          <CommentSection loading={loading} loaderHeight={200} points={commentSectionData} classes='h-full' />
        </div>
      </div>
  
    {benefitArrForSponsoredAndMoneySpent.includes(benefitType) &&(
      <div>
        <div className='text-base font-semibold mt-12 text-gray-700 leading-none'>Utilization across</div>
          <LodingSquareTabbar
            loading={loading}
            loaderHeight={25}
            list={['Departments', 'Location', 'Age', 'Gender']}
            handler={sqaureTabHandler}
            classes='mt-3'
          />
          <div
            className={'mt-3 rounded-md ' + (loading ? '' : 'bg-white ') + (bardata && bardata.length === 0 ? 'pt-6 ' : '')}
          >
          {bardata && bardata.length === 0 && (
            <UserAlert
              para={`${xAxesLabel} data is not available`}
              paraClasses=' font-semibold text-gray-600'
              imgClasses=' h-5 w-5'
              classes=' p-4 ml-6 mr-4'
            />
          )}
          <Bargraph
            id='utilizationbargraph'
            loading={loading}
            loaderHeight={300}
            data={bardata}
            labels={barlabels}
            backgroundColor={barBgColors}
            height='300px'
            type='bar'
            ticks={{
              min: 0,
              max: 120,
              stepSize: 20,
            }}
            dataPoints='percentage'
            barTag='percentage'
            xAxesLabel={xAxesLabel}
            yAxesLabel='Utilization percentages'
          />
        </div>
      </div>)}
      </div>)}
    </div>
  );
};

export default Benefit;
